import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin, Heart } from 'lucide-react';

const Footer = ({ settings = {} }) => {
  return (
    <footer data-testid="site-footer" className="bg-[#2E3A46] text-[#C5D0DA]">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-white font-heading text-xl mb-4">von den Schneeblumen</h3>
            <p className="text-sm leading-relaxed mb-4">
              Heilige Birma Katzenzucht seit 2007. Chocolate & Lilac Point Spezialisten südlich von Hamburg.
            </p>
            <p className="text-xs text-[#7A9BB5]">
              Mitglied im 1. Felidae Cat Club e.V.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-heading text-lg mb-4">Kontakt</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0 text-[#7A9BB5]" />
                <span>Dorothea Schulz<br />Royberg 2c<br />21271 Hanstedt</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} className="shrink-0 text-[#7A9BB5]" />
                <a href="tel:+4917631134989" className="hover:text-white transition-colors">+49(0)176 311 34 989</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} className="shrink-0 text-[#7A9BB5]" />
                <a href="mailto:info@birma-schneeblumen.de" className="hover:text-white transition-colors">info@birma-schneeblumen.de</a>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-heading text-lg mb-4">Rechtliches</h4>
            <div className="space-y-2 text-sm">
              <Link to="/impressum" className="block hover:text-white transition-colors">Impressum</Link>
              <Link to="/datenschutz" className="block hover:text-white transition-colors">Datenschutz</Link>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-heading text-lg mb-4">Folgen Sie uns</h4>
            <div className="flex gap-4">
              {settings.facebook_url && (
                <a
                  href={settings.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-[#354551] flex items-center justify-center hover:bg-[#7A9BB5] transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook size={18} className="text-white" />
                </a>
              )}
              {settings.instagram_url && (
                <a
                  href={settings.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-[#354551] flex items-center justify-center hover:bg-[#7A9BB5] transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={18} className="text-white" />
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#354551] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
          <p>&copy; von den Schneeblumen {new Date().getFullYear()}</p>
          <p className="flex items-center gap-1">
            Mit <Heart size={12} className="text-[#C9A96E]" /> für unsere Birmchen
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
